<div class="innovation-carousel-container w-100 bg--grey-0">
  <div class="container">
    <div id="influenza-carousel-desktop" class="bg--grey-0">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 icon-carousel-row">
          @for (item of leftBannerNode; track item; let i = $index) {
            <div
              class="col-lg-4 col-md-4 col-sm-12 col-xs-12 center-xs icon-carousel-col"
              [class.active]="activeIndex === i" (click)="setActiveIndex(i)">
              <img [alt]="item.altText" [src]="getImage(item.media)" class="icon-carousel-img">
              <!-- <img class="hero--circlechart-chart" alt="image" [src]="getImage(item.mediaPicture)"> -->
              <p>{{ item.headline }}</p>
            </div>
          }
        </div>
      </div>
      <div class="carousel_description_container">
        <div class="carousel-bar-line">
          <div class="active-bar"></div>
          @for (item of leftBannerNode; track item; let i = $index) {
            <div class="bar-segment"
              (click)="onBarLineClick(i)">
            </div>
          }
        </div>
        <div class="carousel-inner">
          @for (item of leftBannerNode; track item; let i = $index) {
            <div class="carousel-item"
              [ngClass]="{'active': activeIndex === i}">
              <div class="row slide--content d-flex">
                <div class="col-lg-12 col-md-12 col-sm-12 left-column">
                  <p class="carousel-content" [innerHTML]="item.largeparagraphcontent"></p>
                  @if (currentSite === 'seqirusb2b-uk') {
                    <p class="potential-factorukflu360"
                    [innerHTML]="item.h3content"></p>
                  }
                  <div class="link-container" [innerHTML]="item.h2content" appRouterlinkinterceptor>
                    <!-- <a [routerLink]="item.link" [innerHTML]="item.h2content"></a> -->
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="influenza-carousel-desktop-btn-container_about_uk">
            <button class="custom-carousel-control-btn custom-carousel-control-prev" type="button"
              (click)="gotoprevious()">
              <span class="custom-icon prev-icon">
                <img alt="Navigate to previous arrow" src="assets/images/prev-btn.svg">
              </span>
            </button>
            <button class="custom-carousel-control-btn custom-carousel-control-next" type="button"
              (click)="gotonext()">
              <span class="custom-icon next-icon">
                <img alt="Navigate to next arrow" src="assets/images/next-btn.svg">
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--mobile-->
<div id="Mobile_Innovation_Carousel_container" class="row-flex  mobile_Innovation_Carousel d-none">
  <div id="innovationResourcesCarousel" class="carousel slide" data-bs-ride="false">
    <ol class="carousel-indicators">
      @for (data1 of leftBannerNode; track data1; let i = $index) {
        <li [attr.data-bs-target]="'#innovationResourcesCarousel'"
        [attr.data-bs-slide-to]="i" [class.active]="i === 0"></li>
      }
    </ol>
    <div class="carousel-inner">
      @for (data1 of leftBannerNode; track data1; let i = $index) {
        <div class="carousel-item carousel-item-innovation" [class.active]="i === 0">
          <div class="top-row">
            <img [src]="getImage(data1?.media)" [alt]="data1?.media?.altText" class="innovationCardImg">
            <p class="innovationHeadline">{{ data1.headline }}</p>
          </div>
          <hr class="innovation_Hr">
          <div class="bottom-row">
            <div class="bottom-row-content">
              <p [innerHTML]="data1.largeparagraphcontent"></p>
              <div class="link-container" [innerHTML]="data1.h2content"></div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="mobile-carousel-btn-container">
      <div type="button" class="mobile_Prev_Btn">
        <span class="custom-icon prev-icon">
          <img alt="Navigate to previous arrow" src="assets/images/prev-btn.svg" class="previous_Img" (click)="prevSlide()">
        </span>
      </div>
      <div type="button" class="mobile_Next_Btn">
        <span class="custom-icon next-icon">
          <img alt="Navigate to previous arrow" src="assets/images/next-btn.svg" class="next_Img" (click)="nextSlide()">
        </span>
      </div>
    </div>
  </div>
</div>
<!-- <div class="carousel-container" *ngIf="isMobile">


<div class="carousel-content">
  <div *ngFor="let item of mergedObject; let i = index" class="carousel-item"
    [ngClass]="{'active': activeIndex === i}">
    <div class="carousel-image">
      <img [alt]="item.altText" [src]="getImage(item.media)" class="icon-carousel-img">
    </div>
    <div class="carousel-text">
      <p class="carousel-content" *ngIf="activeIndex === i" [innerHTML]="item.largeparagraphcontent">
      </p>
      <a href [innerHTML]="item.h2content"></a>
    </div>
    <div class="slick-dots">
      <span *ngFor="let item of mergedObject; let i = index" [class.active]="activeIndex === i"
      (click)="onDotClick(i)"></span>
    </div>
    <div class="influenza-carousel-desktop-btn-container">
      <button class="custom-carousel-control-btn custom-carousel-control-previous" type="button"
        (click)="gotoprevious()">
        <span class="custom-icon prev-icon">
          <img alt="Navigate to previous arrow" src="assets/images/prev-btn.svg">
        </span>
      </button>
      <button class="custom-carousel-control-btn custom-carousel-control-next" type="button"
        (click)="gotonext()">
        <span class="custom-icon next-icon">
          <img alt="Navigate to next arrow" src="assets/images/next-btn.svg">
        </span>
      </button>
    </div>
  </div>
</div>
</div> -->